// removed by extract-text-webpack-plugin
module.exports = {"icon-bar":"IconBar__icon-bar___2HWH7","number":"IconBar__number___1z3V3","number-text":"IconBar__number-text___zEPlD","hash-icon":"IconBar__hash-icon___1eTwh"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Object/IconBar/IconBar.scss
// module id = 930
// module chunks = 0